export default __webpack_public_path__ + "static/media/youtubelogo.aa29d8ca.svg";